//#region Libraries
import { Column, Row } from "components/styles";
import styled from "styled-components";
//#endregion

export const Container = styled(Column).attrs({
	gap: "8px"
})``;
export const Footer = styled(Row).attrs({
	justifyContent: "flex-end",
	width: "100%",
	gap: "10px"
})``;